import { render, staticRenderFns } from "./SequenceCheckEditor.vue?vue&type=template&id=064c16ab&"
import script from "./SequenceCheckEditor.vue?vue&type=script&lang=js&"
export * from "./SequenceCheckEditor.vue?vue&type=script&lang=js&"
import style0 from "./SequenceCheckEditor.vue?vue&type=style&index=0&id=064c16ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports